import Cookies from 'js-cookie'

const TokenKey = 'User-Token'
const clientKey = 'clientInfo'
const reagentTeamKey = 'reagentTeamInfo'
export function getToken() {
  const value = localStorage.getItem(TokenKey)
  if (!value) return ''
  const obj = JSON.parse(value)
  if (obj['expires'] && new Date().getTime() > obj['expires']) {
    // 如果设置了有效期，且已过期，直接清楚
    // localStorage.removeItem(key)
    localStorage.removeItem(TokenKey)
    localStorage.removeItem(clientKey)
    localStorage.removeItem(reagentTeamKey)
    return ''
  }
  // return localStorage.getItem(TokenKey)
  return obj.value
}

export function setToken(token) {
  let expires = new Date().getTime() + 15 * 24 * 60 * 60 * 1000
  let obj = {
    value: token, // 需要缓存的数据
    expires:expires  // 缓存有效期，毫秒为单位
  }
  obj = JSON.stringify(obj)
  return localStorage.setItem(TokenKey, obj)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getClient() {
  return localStorage.getItem(clientKey)
}
//有很多地方需要用到客户相关信息，存到store页面刷新后数据会消失，也存一份到cookies里面
export function setClient(client) {
  return localStorage.setItem(clientKey, client)
}

export function removeClient() {
  return localStorage.removeItem(clientKey)
}

// 商城团队信息与客户信息保持同一份本地缓存策略，供团队业务页面读取。
export function getReagentTeamInfo() {
  return localStorage.getItem(reagentTeamKey)
}

export function setReagentTeamInfo(reagentTeamInfo) {
  return localStorage.setItem(reagentTeamKey, reagentTeamInfo)
}

export function removeReagentTeamInfo() {
  return localStorage.removeItem(reagentTeamKey)
}

export function setLoginCookie(payload) {
  const token =
      typeof payload === 'string'
          ? payload
          : payload && payload.token;

  const expiresAt =
      payload && typeof payload === 'object'
          ? payload.expiresAt
          : undefined;

  if (!token) return;

  const maxAgeSeconds = expiresAt
      ? Math.floor((expiresAt - Date.now()) / 1000)
      : 7 * 24 * 3600;

  const cookie = [
    `User-Token=${encodeURIComponent(token)}`,
    `Domain=.navi-sci.cn`,
    `Path=/`,
    `Max-Age=${Math.max(0, maxAgeSeconds)}`,
    `Secure`,
    `SameSite=None`,
  ].join('; ');

  document.cookie = cookie;
}

export function clearLoginCookie() {
  document.cookie = [
    `User-Token=`,
    `Domain=.navi-sci.cn`,
    `Path=/`,
    `Max-Age=0`,
    `Secure`,
    `SameSite=None`,
  ].join('; ');
}
